<template>
  <div class="flex items-center space-x-1">
    <template
      v-for="(item, index) in visibleItems"
      :key="item.product.id"
    >
      <div class="relative">
        <img
          v-if="getProductImage(item)"
          :src="getProductImage(item)"
          class="size-8 rounded-md border border-gray-200 bg-white object-cover sm:size-10 md:size-12"
          :alt="item.product.name"
        />
        <img
          v-else
          :src="defaultImage"
          class="size-8 rounded-md border border-gray-200 bg-white object-cover sm:size-10 md:size-12"
          alt="Sin imagen"
        />
        <div
          v-if="showOverlay && index === maxImages - 1"
          class="absolute inset-0 flex items-center justify-center rounded-md bg-black/60 font-semibold text-white"
        >
          +{{ extraCount }}
        </div>
      </div>
    </template>
  </div>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import greenKImage from 'assets/images/green-k.jpg';
import useProductImage from '../use/product-image';

const props = defineProps<{ products: Item[] }>();

const defaultImage = greenKImage;
const maxImages = 4;

function getProductImage(item: Item): string {
  const { productImageToShow } = useProductImage(item.product, 'jpgSm');
  return productImageToShow.value || defaultImage;
}

const visibleItems = computed(() => {
  if (props.products.length > maxImages) {
    return props.products.slice(0, maxImages);
  }
  return props.products;
});

const showOverlay = computed(() => props.products.length > maxImages);
const extraCount = computed(() => props.products.length - maxImages);
</script>
